import { useFormik } from "formik";
import appActions from "../../../appActions";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useEffect, useMemo, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import { fileGroupOptions, isPermissionCodeValid, trueFalseOptions } from "../../../utils/mics";

const LevelOptions = [
    { label: "INFO", value: "INFO" },
    { label: "ERROR", value: "ERROR" },
    { label: "DEBUG", value: "DEBUG" },
    { label: "WARN", value: "WARN" },
];

const LogsParser = ({ pageId }) => {
    
    const readAccess = isPermissionCodeValid(`${pageId}-R`);
    // const writeAccess = isPermissionCodeValid(`${pageId}-W`);
    // const deleteAccess = isPermissionCodeValid(`${pageId}-D`);

    const dispatch = useDispatch();

    const [filteredLogs, setFilteredLogs] = useState([]);
    const [logLevelFilter, setLogLevelFilter] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const formik = useFormik({
        initialValues: {
            logFilePath: '/usr/dxp/logs/dxp-vssap-service.log',
            isDirectory: false,
            filterBy: '',
            download: false,
            mode: 'web'
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                //dateFrom: values.dateFrom ? moment(values.dateFrom).format('YYYY-MM-DD') : '',
            };
            dispatch(appActions.EXPORTLOGS_GET_LOG_PARSER_REQUEST(data));
        },
    });


    const logStr = useSelector((state) => state?.devOpsTool?.logStr);

    const handleClear = () => {
        formik.resetForm();
    };

    const renderHeader = () => (
        <div className="col-12">
            <h1 className="page-header flex"> Log Parser </h1>
        </div>
    );

    const handleChange = (e) => {
        formik.handleChange(e);
    }

    useEffect(() => {
        applyFilter();
    }, [logStr, logLevelFilter, startDate, endDate]); 
    
    const applyFilter = () => {
        
        if (!logStr) return;

        let logEntries = logStr.split("-------------------------").map(entry => entry.trim());

        // Apply log level filter
        if (logLevelFilter) {
            logEntries = logEntries.filter(log => log.includes(`Level: ${logLevelFilter}`));
        }

        // Apply date filters
        if (startDate || endDate) {
            logEntries = logEntries.filter(log => {
                const match = log.match(/Time:\s(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2},\d{3})/);
                if (match) {
                    const logTime = moment(match[1], "YYYY-MM-DD HH:mm:ss,SSS");
                    if (startDate && logTime.isBefore(moment(startDate))) return false;
                    if (endDate && logTime.isAfter(moment(endDate))) return false;
                    return true;
                }
                return false;
            });
        }

        setFilteredLogs(logEntries);
    };

    const clearFilters = () => {
        setLogLevelFilter(null);
        setStartDate(null);
        setEndDate(null);
        if (logStr) {
            setFilteredLogs(logStr.split("-------------------------").map(entry => entry.trim()));
        }
    };
    
    const bindFilteredLogs = useMemo(() => {

        if (!logStr) return;


        if (!filteredLogs.length) {
            return <p>No logs found for the selected filters.</p>;
        }

        const handleCopyLog = (log) => {
            // Create a temporary textarea element to copy log content
            const textarea = document.createElement("textarea");
            textarea.value = log; // Set log content to be copied
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
    
            // Optional: You can show a toast or some feedback for copy success
            alert("Log copied to clipboard!");
        };
    
    
        return (
            <div className="log-content mt-3">
                {filteredLogs.length ? (
                    filteredLogs.map((log, index) => (
                        <div className="log-entry" key={index}>
                            <div dangerouslySetInnerHTML={{ __html: log }}></div>

                            {/* Copy icon displayed on hover */}
                            <i
                                className="pi pi-copy tp"
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    cursor: 'pointer',
                                    visibility: 'hidden'
                                }}
                                onClick={() => handleCopyLog(log)}
                            />

                        </div>
                    ))
                ) : (
                    <p>No logs found for the selected filters.</p>
                )}
            </div>
        );
    }, [filteredLogs, logStr]);


    const renderList = () => (
        <>

            <div className="grid px-4 align-items-center my-2">{renderHeader()}</div>

            <div className="bg-white mx-4 pv-20 ph-20 br-6 shadow-white">
                <>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="grid p-2">
                            <div className="p-fluid formgrid grid w-full">

                                <div className="col-4 mb-2">
                                    <label htmlFor="isDirectory">Is Directory*</label>
                                    <Dropdown filter showClear value={formik.values.isDirectory} onChange={formik.handleChange} options={trueFalseOptions}  id="isDirectory" name="isDirectory" optionLabel="name" optionValue='code' />
                                </div>

                                <div className="col-4 mb-2">
                                    <label htmlFor="logFilePath">Log {formik.values.isDirectory ? 'Directory' : 'File'} Path</label>
                                    <InputText id="logFilePath" name="logFilePath" type="text" value={formik.values.logFilePath} onChange={handleChange} />
                                </div> 

                                <div className="col-4 mb-2">
                                    <label htmlFor="download">Download*</label>
                                    <Dropdown filter showClear value={formik.values.download} onChange={formik.handleChange} options={trueFalseOptions}  id="download" name="download" optionLabel="name" optionValue='code' />
                                </div>

                                 <div className="col-4 mb-2">
                                    <label htmlFor="filterBy">Filter By</label>
                                    <InputText id="filterBy" name="filterBy" placeholder="Enter keywords separated by commas (e.g., error, warning, failed)" type="text" value={formik.values.filterBy} onChange={handleChange} />
                                </div> 
                                
                            </div>
                        </div>

                        <div className="grid px-2 py-4 flex-row-reverse gap-10">
                            {readAccess && <>
                                <Button type="submit" icon="pi pi-search" label="Submit" severity="success" outlined className="p-button-success mr-2" />
                                <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset" label="Reset" severity="secondary" outlined onClick={handleClear} />
                            </>}
                        </div>
                    </form>
                </>
            </div>
        </>
    );




    useEffect(() => {
        if (logStr) {
            const logEntries = logStr.split("-------------------------").map(entry => entry.trim());
            setFilteredLogs(logEntries); // Default to all logs
        }
    }, [logStr]);

    return <div className="form_height">

        {renderList()}

        {logStr && <div className="bg-white mx-4 pv-20 ph-20 br-6 shadow-white mt-1">
            {bindFilteredLogs}
        </div>
        }
    </div>;
};

export default LogsParser;